<div class="container">
    <div class="warehouse-container">
        <!-- Header -->
        <div class="page-header">
            <div class="breadcrumb">
                <span class="breadcrumb-item" (click)="cancel()">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                        stroke="currentColor" class="icon">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M2.25 12l8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25" />
                    </svg>
                    Warehouses
                </span>
                <span class="breadcrumb-separator">></span>
                <span *ngIf="isAddMode" class="breadcrumb-item active">Add Warehouse</span>
                <span *ngIf="!isAddMode" class="breadcrumb-item active">Edit Warehouse</span>
            </div>
            <button class="btn-back" (click)="goBack()">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor" class="icon">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" />
                </svg>
                Go Back
            </button>
        </div>
        <!-- Form Section -->
        <div class="form-section">
            <!-- Warehouse Name -->
            <div class="form-group">
                <label class="form-label">Warehouse Name<span class="required-star">*</span></label>
                <input type="text" class="form-input" [(ngModel)]="warehouseForm.warehouseName"
                    [class.error]="errors['warehouseName']" placeholder="Enter warehouse name"
                    (input)="capitalizeInput('warehouseName')">
                <div class="error-message show" *ngIf="errors['warehouseName']">
                    <svg fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd"
                            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                            clip-rule="evenodd" />
                    </svg>
                    {{errors['warehouseName']}}
                </div>
            </div>

            <!-- Company Address with Add Button -->
            <div class="form-group">
                <label class="form-label">Company Address<span class="required-star">*</span></label>
                <div style="display: grid; grid-template-columns: 1fr auto; gap: 12px; align-items: start;">
                    <div class="combo-wrapper">
                        <input type="text" class="combo-input" [(ngModel)]="warehouseForm.companyAddress"
                            [class.error]="errors['companyAddress']" placeholder="Enter or select company address"
                            (input)="filterAddresses()" (blur)="hideDropdownDelayed()" autocomplete="off">
                        <div class="combo-dropdown-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                                stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                            </svg>
                        </div>
                        <div class="combo-dropdown" *ngIf="showDropdown && addressData.length > 0">
                            <div class="combo-option" *ngFor="let address of addressData"
                                (mousedown)="selectAddress(address)">
                                {{address.address}}
                            </div>
                        </div>
                    </div>
                    <button class="btn-add-address" (click)="openDialog('0ms', '0ms')" type="button"
                        style="width: auto; white-space: nowrap; padding: 10px 16px;">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                            stroke="currentColor" style="width: 16px; height: 16px;">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                        </svg>
                        Add Address
                    </button>
                </div>
                <div class="error-message show" *ngIf="errors['companyAddress']">
                    <svg fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd"
                            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                            clip-rule="evenodd" />
                    </svg>
                    {{errors['companyAddress']}}
                </div>
            </div>

            <!-- Contact Name & Email -->
            <div class="form-row">
                <div class="form-group" style="margin-bottom: 0;">
                    <label class="form-label">Contact Name<span class="required-star">*</span></label>
                    <input type="text" class="form-input" [(ngModel)]="warehouseForm.contactName"
                        [class.error]="errors['contactName']" placeholder="John Doe"
                        (input)="capitalizeInput('contactName')">
                    <div class="error-message show" *ngIf="errors['contactName']">
                        <svg fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd"
                                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                                clip-rule="evenodd" />
                        </svg>
                        {{errors['contactName']}}
                    </div>
                </div>
                <div class="form-group" style="margin-bottom: 0;">
                    <label class="form-label">Email<span class="required-star">*</span></label>
                    <input type="email" class="form-input" [(ngModel)]="warehouseForm.email"
                        [class.error]="errors['email']" placeholder="example@email.com">
                    <div class="error-message show" *ngIf="errors['email']">
                        <svg fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd"
                                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                                clip-rule="evenodd" />
                        </svg>
                        {{errors['email']}}
                    </div>
                </div>
            </div>

            <!-- Country Code, Phone, Alternate Phone -->
            <div class="form-row-3">
                <div class="form-group" style="margin-bottom: 0;">
                    <label class="form-label">Country Code<span class="required-star">*</span></label>
                    <select class="form-input country-select" [(ngModel)]="warehouseForm.countryCode">
                        <option *ngFor="let country of countryCodes" [value]="country.dial_code">
                            {{ country.code }} {{ country.dial_code }}
                        </option>
                    </select>
                </div>
                <div class="form-group" style="margin-bottom: 0;">
                    <label class="form-label">Phone<span class="required-star">*</span></label>
                    <input type="tel" class="form-input" [(ngModel)]="warehouseForm.phone"
                        [class.error]="errors['phone']" placeholder="1234567890" maxlength="10"
                        (input)="onPhoneInput('phone')" (keypress)="keyPressNumbers($event)">
                    <div class="error-message show" *ngIf="errors['phone']">
                        <svg fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd"
                                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-10a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                                clip-rule="evenodd" />
                        </svg>
                        {{errors['phone']}}
                    </div>
                </div>
                <div class="form-group" style="margin-bottom: 0;">
                    <label class="form-label">Alternate Phone</label>
                    <input type="tel" class="form-input" [(ngModel)]="warehouseForm.altPhone"
                        [class.error]="errors['altPhone']" placeholder="0987654321" maxlength="10"
                        (input)="onPhoneInput('altPhone')" (keypress)="keyPressNumbers($event)">
                    <div class="error-message show" *ngIf="errors['altPhone']">
                        <svg fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd"
                                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                                clip-rule="evenodd" />
                        </svg>
                        {{errors['altPhone']}}
                    </div>
                </div>
            </div>
        </div>

        <!-- Action Buttons -->
        <div class="form-actions">
            <button class="btn btn-cancel" (click)="cancel()" type="button">Cancel</button>
            <button *ngIf="isAddMode" class="btn btn-submit" (click)="submitWarehouse()" type="button"
                [disabled]="loading">
                <ng-container *ngIf="!loading">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                        stroke="currentColor" style="width: 18px; height: 18px; margin-right: 6px;">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                    </svg>
                    Add Warehouse
                </ng-container>
                <ng-container *ngIf="loading">
                    <div class="btn-spinner"></div>
                    Processing...
                </ng-container>
            </button>
            <button *ngIf="!isAddMode" class="btn btn-submit" (click)="submitWarehouse()" type="button"
                [disabled]="loading">
                <ng-container *ngIf="!loading">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                        stroke="currentColor" style="width: 18px; height: 18px; margin-right: 6px;">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                    </svg>
                    Update Warehouse
                </ng-container>
                <ng-container *ngIf="loading">
                    <div class="btn-spinner"></div>
                    Updating...
                </ng-container>
            </button>
        </div>
    </div>
</div>